// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3mZcV","content":"GlobalSearch_content__2uD-i"};